// extracted by mini-css-extract-plugin
export default {"wrapper":"Fixed_wrapper__vHnDV","wrapperFull":"Fixed_wrapperFull__wgJRr","headerWrapper":"Fixed_headerWrapper__ECZyF"};